import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";

import { useMediaQuery } from "context/media/MediaContext";
import { TokenInclude } from "helpers/GetToken";
import { setRemove } from "redux/slices/EmployeeManagementSlice";
import { SetEmployeeOperations } from "services/employeeManagement.service";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row, Seperator } from "../../BaseComponents/Flex";
import InsideSpinner from "components/BaseComponents/Spinner/InsideSpinner";

interface EmployeeRemoveModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
  phoneNumber: string;
}

const EmployeeRemoveModal: FC<EmployeeRemoveModalProps> = ({
  title,
  message,
  acceptButtonText,
  rejectButtonText,
  setIsOpen,
  phoneNumber,
}) => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  const dispatch = useAppDispatch();
  const token = TokenInclude();

  const [loading, setLoading] = useState<boolean>(false);
  const [isServiceOK, setIsServiceOK] = useState<boolean>(false);
  const [pn, setpn] = useState("");

  const onAcceptClick = async () => {
    setLoading(true);
    const isRemove = await SetEmployeeOperations(token, pn, "3");
    if (isRemove.Issucceeded) {
      dispatch(setRemove(phoneNumber));
      setIsServiceOK(true);
      setLoading(false);
    }
  };

  const onRejectClick = (): void => setIsOpen(false);

  useEffect(() => {
    if (isServiceOK) {
      setIsOpen(false);

      navigate("/employee-panel", {
        state: { fromAddOrEditAgent: false },
      });
    }
  }, [isServiceOK]);

  useEffect(() => {
    phoneNumber && setpn(phoneNumber);
  }, [phoneNumber]);

  return (
    <Modal info={message} maxWidth={450} setIsOpen={setIsOpen} title={title}>
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button
            color='light'
            onClick={onAcceptClick}
            text={
              loading ? (
                <InsideSpinner width='30' height='30' isWhite={true} />
              ) : (
                acceptButtonText
              )
            }
          />
        </Col>

        <Seperator marginRight={20} marginTop={isMobile ? 10 : 0} />

        <Col size={0.3}>
          <Button onClick={onRejectClick} text={rejectButtonText} />
        </Col>
      </Row>
    </Modal>
  );
};

export default EmployeeRemoveModal;
